module.exports = __webpack_public_path__ + "static/img/manual-20.2d8a40a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-20.png
// module id = S/bD
// module chunks = 4